import { cn } from "@fatbees/ui-utils";
import {
  Children,
  cloneElement,
  ForwardedRef,
  forwardRef,
  isValidElement,
  ReactElement,
  ReactNode,
  useId,
} from "react";
import { Label } from "./label";

export interface LabelledComponentProps {
  className?: string;
  children?: ReactNode;
  label?: ReactNode;
}

export const LabelledComponent = forwardRef(function LabelledComponent(
  { className, children, label }: LabelledComponentProps,
  ref: ForwardedRef<HTMLDivElement>,
) {
  const id = useId();
  const enhancedChildren = Children.map(children, (child) => {
    if (isValidElement(child)) {
      let props = child.props;

      // eslint-disable-next-line react/prop-types
      if (props.id === undefined) {
        props = { ...props, id };
      }

      return cloneElement(child as ReactElement, props);
    }
    return child; // keep non-element children as-is
  });

  return (
    <div ref={ref} className={cn("flex flex-col gap-1.5", className)}>
      <Label className="ml-1" htmlFor={id}>
        {label}
      </Label>
      {enhancedChildren}
    </div>
  );
});
